import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import { BadgeWrapper } from './styles'
import { CHANGED_REQUIREMENT_STATUS } from 'modules/core/constants'
import { useTranslation } from 'react-i18next'
import { getBadgeColor } from './styles'

const CombinedChangedStatusBadge = ({ size, statuses, showTooltip }) => {
	const [t] = useTranslation()
	const [leftStatus, rightStatus] = statuses
	const leftColor = getBadgeColor(leftStatus)
	const rightColor = getBadgeColor(rightStatus)
	const tooltipTitle = statuses
		.map(status =>
			t(`approval.report.requirementsTable.changedStatus.${status}`)
		)
		.join(' + ')

	return (
		<Tooltip placement="right" title={showTooltip && tooltipTitle}>
			<BadgeWrapper circleSize={size}>
				<span
					style={{
						display: 'inline-block',
						width: size,
						height: size,
						borderRadius: '50%',
						background: `linear-gradient(90deg, ${leftColor} 50%, ${rightColor} 50%)`,
						boxSizing: 'border-box',
						verticalAlign: 'middle'
					}}
				/>
			</BadgeWrapper>
		</Tooltip>
	)
}

CombinedChangedStatusBadge.propTypes = {
	size: PropTypes.number,
	statuses: PropTypes.arrayOf(
		PropTypes.oneOf(Object.values(CHANGED_REQUIREMENT_STATUS))
	),
	showTooltip: PropTypes.bool
}

CombinedChangedStatusBadge.defaultProps = {
	size: 16,
	statuses: [
		CHANGED_REQUIREMENT_STATUS.CHANGED,
		CHANGED_REQUIREMENT_STATUS.CHANGED_ASSIGNMENT
	],
	showTooltip: true
}

export default CombinedChangedStatusBadge
